module.exports = __webpack_public_path__ + "media/images/weather/43_night-867efd747c0d1e23047ad72afa5a7357.png";